import { AxiosInstance } from "axios";
import type { GoogleCalendarRef } from "./GoogleCalendarSourceSettings.types";

export class GoogleCalendarSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  /** Calendars the connected account can read, primary first. */
  async getCalendars(boardId: string, connectionId: string): Promise<GoogleCalendarRef[]> {
    const response = await this.client.get<GoogleCalendarRef[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/googlecalendar/calendars`,
    );
    return response.data;
  }
}
